import styled from '@emotion/styled'

export const Container = styled('div')`
  display: flex;
`

export const Box = styled('div')``
